module.exports = __webpack_public_path__ + "img/change_wild.b7a23094.png";